import ao from './roles/ao';
import aoClientEvidences from './roles/ao-client-evidences';
import aoClientFiles from './roles/ao-client-files';
import aoClientInvoicing from './roles/ao-client-invoicing';
import aoClientStaff from './roles/ao-client-staff';
import aoOwner from './roles/ao-owner';
import aocOwner from './roles/aoc-owner';
import broker from './roles/broker';
import demo from './roles/demo';
import developer from './roles/developer';
import hub from './roles/hub.js';
import impersonate from './roles/impersonate';
import IndustryAo from './roles/industry-ao.js';
import IndustrySaas from './roles/industry-saas.js';
import staffAccounting from './roles/staff-accounting';
import staffFiles from './roles/staff-files';
import staffInvoicing from './roles/staff-invoicing';
import staffKsef from './roles/staff-ksef';
import staffStaffs from './roles/staff-staffs';
import webmaster from './roles/webmaster';

export default {
  'ao-client-evidences': aoClientEvidences,
  'ao-client-files': aoClientFiles,
  'ao-client-invoicing': aoClientInvoicing,
  'ao-client-staff': aoClientStaff,
  'ao-owner': aoOwner,
  'aoc-owner': aocOwner,
  'developer': developer,
  'impersonate': impersonate,
  'industry:1': IndustrySaas,
  'industry:2': IndustryAo,
  'staff-accounting': staffAccounting,
  'staff-files': staffFiles,
  'staff-invoicing': staffInvoicing,
  'staff-staffs': staffStaffs,
  'staff-ksef': staffKsef,
  webmaster,
  ao,
  broker,
  demo,
  hub,
};
